import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/hooks/useAuth";
import { useIsTablet } from "@/hooks/use-mobile";
import { PageHeader } from "@/components/layout/PageHeaderSlot";
import { UserHeader, UserListing, UserStats } from "@/components/users";

const usersSearchSchema = z.object({
  page: z.coerce.number().int().positive().catch(1),
  pageSize: z.coerce.number().int().positive().catch(50),
  search: z.string().optional(),
  sortBy: z.string().optional(),
  sortOrder: z.enum(["asc", "desc"]).optional(),
  status: z.enum(["all", "active", "inactive"]).catch("all"),
});

export const Route = createFileRoute("/(protected)/_layout/_org/users/")({
  validateSearch: (search) => usersSearchSchema.parse(search),
  component: UsersTab,
});

function UsersTab() {
  const isTablet = useIsTablet();
  const { hasRole } = useAuth();
  const searchParams = Route.useSearch();
  const navigate = useNavigate();
  const isInternalAdmin = hasRole("SUPER_ADMIN") || hasRole("SUPPORT");

  return (
    <div className="flex flex-col gap-5">
      {isInternalAdmin ? (
        isTablet ? (
          <PageHeader>
            <UserHeader tablet />
          </PageHeader>
        ) : (
          <UserHeader />
        )
      ) : null}

      {isInternalAdmin ? <UserStats adminScope /> : null}

      <UserListing
        adminScope={isInternalAdmin}
        showSectionHeader={!isInternalAdmin}
        searchParams={searchParams}
        onNavigate={(updater) =>
          void navigate({ from: "/users/", search: updater, replace: true })
        }
        onRowClick={(user) =>
          void navigate({
            to: "/users/$userId",
            params: { userId: String(user.id) },
          })
        }
      />
    </div>
  );
}
